import moment from 'moment-timezone';

/** Giờ VN dùng để đồng bộ với BE (occurred_at + subHours(7)). */
export const VIETNAM_TZ = 'Asia/Ho_Chi_Minh';

function normalizeWallClock(dateYmd: string, timeHms: string): string {
  const t = timeHms.trim();
  const timeNorm = t.split(':').length === 2 ? `${t}:00` : t;
  return `${dateYmd.trim()} ${timeNorm}`;
}

/**
 * Offset phút so với UTC từ cấu hình Antoree (UTC+7, UTC+8, ...).
 * Không dùng cho tên IANA.
 */
export function userSettingsToUtcOffsetMinutes(
  userTimeZone: string | undefined | null,
): number {
  const raw = (userTimeZone || '').trim();
  if (!raw) {
    return 7 * 60;
  }
  const upper = raw.toUpperCase();
  if (upper === 'UTC') {
    return 0;
  }
  const m = upper.match(/^UTC([+-])(\d+(?:\.\d+)?)$/);
  if (m) {
    const sign = m[1] === '-' ? -1 : 1;
    return sign * Math.round(parseFloat(m[2]) * 60);
  }
  return 7 * 60;
}

/**
 * Chuỗi hiển thị múi giờ trong form (từ / không có → mặc định UTC+7).
 */
export function formatUserTimezoneCaption(
  userTimeZone: string | undefined | null,
): string {
  const raw = (userTimeZone || '').trim();
  if (!raw) {
    return 'UTC+7';
  }
  if (/^UTC[+-]/i.test(raw) || raw.toUpperCase() === 'UTC') {
    return raw.toUpperCase() === 'UTC' ? 'UTC' : raw;
  }
  if (moment.tz.zone(raw)) {
    const z = moment.tz('2020-06-15 12:00', raw);
    if (z.isValid()) {
      const gmt = z.format('Z');
      return `${raw} (GMT${gmt})`;
    }
  }
  return raw;
}

/**
 * Giờ trên form = giờ tường tại múi giờ tài khoản (settings).
 */
export function parseWallClockInUserSettings(
  dateYmd: string,
  timeHms: string,
  userTimeZone: string | undefined | null,
): moment.Moment {
  const wall = normalizeWallClock(dateYmd, timeHms);
  const raw = (userTimeZone || '').trim();

  if (!raw || /^UTC[+-]/i.test(raw) || raw.toUpperCase() === 'UTC') {
    const mins = userSettingsToUtcOffsetMinutes(raw || undefined);
    const m = moment(wall, 'YYYY-MM-DD HH:mm:ss', true);
    return m.utcOffset(mins, true);
  }
  if (moment.tz.zone(raw)) {
    return moment.tz(wall, 'YYYY-MM-DD HH:mm:ss', raw);
  }
  const mins = userSettingsToUtcOffsetMinutes('UTC+7');
  return moment(wall, 'YYYY-MM-DD HH:mm:ss', true).utcOffset(mins, true);
}

/**
 * Đổi instant sang giờ tường VN (tiện cho hiển thị / legacy).
 * API edit-unit/add-unit (BE đã dùng DateTimeHelper::fromUser) nhận giờ tường theo `user.settings.timezone`.
 */
export function toVietnamWallStringForApi(m: moment.Moment): string {
  return m.clone().tz(VIETNAM_TZ).format('YYYY-MM-DD HH:mm:ss');
}
